import React, { useState } from 'react'
import InputAdornment from '@material-ui/core/InputAdornment'
import IconButton from '@material-ui/core/IconButton'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import { Collapse } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@material-ui/styles'
import { Error } from '@material-ui/icons'
import { muiNoOutline } from '../../utils'
import { useSelector } from 'react-redux'
import config from '../../config'

function PasswordField ({ formik, name, label, withAlert, ...rest }) {
  const { theme: { bgColors, colors } } = useTheme()
  const [isFocused, setIsFocused] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const { t } = useTranslation()
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const isContrast = themeState !== config.THEMES_MODES.LIGHT
  const classes = muiNoOutline()

  return (
    <div style={{ width: '100%' }}>
      <FormControl className={`mb-1`} fullWidth variant="outlined"
                   error={formik.touched[name] && Boolean(formik.errors[name])}>
        <InputLabel style={{color: colors.colorText}} htmlFor="outlined-adornment-password">{label}</InputLabel>
        <OutlinedInput
          classes={isContrast ? { root: classes.root } : {}}
          name={name}
          onInput={() => setIsFocused(true)}
          id="outlined-adornment-password"
          type={showPassword ? 'text' : 'password'}
          style={{ color: colors.colorText, backgroundColor: bgColors.bgPrimary200 }}
          value={formik.values[name]}
          onChange={formik.handleChange}
          {...rest}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => setShowPassword(!showPassword)}
                onMouseDown={e => e.preventDefault()}
                edge="end"
                style={{ marginRight: '1px', color: colors.colorMutedText }}
              >
                {showPassword ? <Visibility/> : <VisibilityOff/>}
              </IconButton>
            </InputAdornment>
          }
          labelWidth={label.length * 9}
        />
        <FormHelperText id="outlined-adornment-password">{formik.touched[name] && formik.errors[name]}</FormHelperText>
      </FormControl>
      <Collapse in={isFocused}>

        {(withAlert && formik.errors.password) ?
          <Alert className={`mb-1`} style={{ backgroundColor: bgColors.bgModalError, color: colors.colorStatusError}} severity="error" iconMapping={{error: <Error style={{ color: colors.colorStatusError }} />}}>
            <p dangerouslySetInnerHTML={{ __html: t(formik.errors.password) }}/>
          </Alert>
          : (!withAlert && formik.errors.repeatedPassword) &&
          <Alert className={`mb-1`} style={{ backgroundColor: bgColors.bgModalError, color: colors.colorStatusError}} severity="error" iconMapping={{error: <Error style={{ color: colors.colorStatusError }} />}}>
            {t(formik.errors.repeatedPassword)}
          </Alert>}
      </Collapse>
    </div>
  )
}

export default PasswordField
